<div class="dashboard--module-header">
    <h2 class="subheading-sm">Beyond Emergency Credit<button class="info-btn focus-element" (click)="onInfoClick()"><span class="focus--content" tabindex="-1"><span>i</span></span></button></h2>
</div>
<div class="module--main">
    <issues-beyond-emergency-credit-chart class="block-chart"></issues-beyond-emergency-credit-chart>
    <div class="block-detail">
        <table class="std-table stacked-sm" *ngIf="data.length > 0">
            <thead>
            <th>Consumer name</th>
            <th>Supply address</th>
            <th>kWh consumed since E/C exhausted</th>
            <th>m3 consumed since E/C exhausted</th>
            <th>Days since E/C exhausted</th>
            <th>Credit status</th>
            </thead>
            <tbody>
                <tr *ngFor="let item of data">
                    <td data-label="Consumer name">{{item.consumerName}}</td>
                    <td data-label="Supply address">{{item.consumerAddress}}</td>
                    <td data-label="kWh consumed since E/C exhausted">{{item.consumptionSinceEmergencyCreditKWh}}</td>
                    <td data-label="m3 consumed since E/C exhausted">{{item.consumptionSinceEmergencyCreditM3}}</td>
                    <td data-label="Days since E/C exhausted">{{item.numberOfDaysConsuming}}</td>
                    <td data-label="Credit status">{{item.latestCreditStatus | currency:'GBP'}}</td>
                    <td class="text-right"><a [routerLink]="['/portal/'+ clientId +'/consumer',item.consumerId]" class="text-link focus-element"><span class="focus--content">View</span></a></td>
                </tr>
            </tbody>
        </table>
        <app-pagination *ngIf="data.length > 0" [page]="page" [pages]="totalPages" (pageChange)="getPage($event)"></app-pagination>
    </div>
</div>
